import { Flex, Space, Typography } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { formatDate } from 'shared/utils/time/format-date';
import { CargoItemStatuses } from 'client-app/components/client-cargos/cargo-item-status';
import { DocumentsListModal } from 'client-app/components/documents/documents-list-modal';
import { CargoAddresses } from '../cargo-addresses';
import { CargoMapModal } from '../cargo-map-modal';
import styles from './cargo-item.module.scss';
import type { ICargoItemProps } from './types';
import { generateDateString, isCargoInProgress } from './utils';

const { Text } = Typography;

export const CargoItem: React.FC<ICargoItemProps> = ({ cargo }) => {
  const loadingDateFrom = formatDate(cargo.loadingDateFrom);
  const loadingDateTo = formatDate(cargo.loadingDateTo);
  const unloadingDateFrom = formatDate(cargo.unloadingDateFrom);
  const unloadingDateTo = formatDate(cargo.unloadingDateTo);

  const loadingDates = generateDateString(loadingDateFrom, loadingDateTo);
  const unloadingDates = generateDateString(unloadingDateFrom, unloadingDateTo);

  const isGeoAvailable = isCargoInProgress(cargo.statuses);

  return (
    <Space key={cargo.id} direction='vertical' className={styles.wrapper}>
      <Flex align='flex-start' gap={14}>
        <Text className={styles.cargoId}>{cargo.compositeId}</Text>
        <CargoAddresses cargo={cargo} />
        <div>
          <CargoItemStatuses statuses={cargo.statuses} />
        </div>
        <div className={styles.cargoItemAdditionalInfo}>
          {isGeoAvailable && <CargoMapModal cargoId={cargo.id} />}
          <DocumentsListModal cargoId={cargo.id} />
        </div>
      </Flex>
      <Flex>
        <Text type='secondary' className={styles.dates}>
          {loadingDates}
          <ArrowRightOutlined className={styles.arrow} />
          {unloadingDates}
        </Text>
      </Flex>
    </Space>
  );
};
